<template>
  <div>
    <input
      v-if="field.canEdit"
      type="file"
      @change="onFileChanged"
    />
  </div>
</template>

<script>
import moment from 'moment'
import utf8 from 'utf8'
import api from './../../../api'
import sharedComputed from './../../computed'
import sharedMethods from './../../methods'
import formElementProps from './formElementProps'
const HtmlTableToJson = require('html-table-to-json')

const regions = {
  1: '5bc8701035e8e07d222a25a5', // Torremolinos
  2: '5bc8701935e8e07d222a25a6', // Benalmádena
  3: '5bc8702235e8e07d222a25a7', // Fuengirola
  4: '5bc8703235e8e07d222a25a8', // Mijas
  5: '5bc8703635e8e07d222a25a9', // Marbella
  6: '5bc8703935e8e07d222a25aa', // Estepona
  7: '5bc8703e35e8e07d222a25ab' // Manilva
}

let turismiluba = {}

function toDataURL (url, callback) {
  var xhr = new XMLHttpRequest();
  xhr.onload = function() {
    var reader = new FileReader();
    reader.onloadend = function() {
      callback(reader.result);
    }
    reader.readAsDataURL(xhr.response);
  };
  xhr.open('GET', url);
  xhr.responseType = 'blob';
  xhr.send();
}

export default {
  name: 'FormFile',

  props: {
    ...formElementProps
  },

  data: () => {
    return {
      uploadedFile: null
    }
  },

  computed: {
    ...sharedComputed
  },

  created () {
  },

  methods: {
    ...sharedMethods,

    onFileChanged (event) {
      let file = event.target.files[0]
      const extension = file.name.split('.').pop()

      if (['json', 'csv', 'pdf'].includes(extension)) {
        const reader = new FileReader()
        reader.onload = e => {
          this.value[this.field.fieldName] = e.target.result
          this.value[this.field.fieldName + 'Name'] = file.name
          this.value[this.field.fieldName + 'Extention'] = extension
          this.uploadedFile = e.target.result
          this.importData(e.target.result)
        }
        reader.readAsDataURL(file)
      }
    },

    getJson (filedata) {
      let base64 = filedata.split(',')[1]
      return JSON.parse(atob(base64))
    },

    importImages (data) {
      let objects = {}
      api.getListItemsToStore(this.apiUrl, 'objects', [{
        key: 'rowsPerPage',
        value: 500
      }]).then(response => {
        response.items.forEach(item => {
          objects[item.csrId] = item._id
        })

        // ..
        let prepped = []
        for (let i = 2000; i < 3000; i++) {
          let newo = {}
          let old = data[2].data[i]

          //

          if (old && old.add_timestamp) {
            toDataURL('/object-pics/' +
              old.rental_object_id + '_1_' + old.image_id + '.jpg', (dataUrl) => {
              // console.log('RESULT:', dataUrl)

              newo.created_at = old.add_timestamp
              newo.image = dataUrl
              newo.object = objects[old.rental_object_id]
              newo.sortOrder = parseInt(old.sort_order)
              newo.active = old.active === '1' ? 1 : 0
              newo.imageExtention = 'jpg'
              newo.imageName = old.image_id + '.jpg'

              if (old.active === '1') {
                if (newo.object) {
                  api.saveItem(this.apiUrl, 'objectImages', newo)
                } else {
                  console.log('no object', old)
                }
              }
            })
          }
        }
      })
    },

    importBookings (data) {
      let prepped = []
      api.getListItemsToStore(this.apiUrl, 'objects', [{
        key: 'rowsPerPage',
        value: 1000
      }]).then(response => {
        let objectsByOldId = {}
        response.items.forEach(item => {
          objectsByOldId[item.csrId] = item
        })
        data[2].data.forEach(old => {
          let newo = {}
          newo.customerName = utf8.decode(old.comments)
          newo.status = '5bebc64a46853c27bcfe3dc8'
          newo.dateStart = moment(moment(old.start_date).format('YYYY-MM-DD')).add(12, 'hours').format()
          // console.log(old.start_date, ' > ', newo.dateStart)
          newo.dateEnd = moment(moment(old.end_date).format('YYYY-MM-DD')).add(12, 'hours').format()
          // console.log(old.end_date, ' > ', newo.dateEnd)
          newo.createdAt = moment(old.insert_timestamp).format()
          if (objectsByOldId[old.rental_object_id]) {
            newo.object = objectsByOldId[old.rental_object_id]['_id']
            prepped.push(newo)
          } else {
            console.log('missing', old)
          }
        })
        console.log('prepped', prepped)
        prepped.forEach(item => {
          api.saveItem(this.apiUrl, 'bookings', item).then(response => {
            console.log('response', JSON.stringify(response))
          })
        })
      })

    },

    importObjects (data) {
      let prepped = []
      for (let i = 0; i < 300; i++) {
        let newo = {}
        let old = data[2].data[i]
        if (old && old.object_name) {
          let parts = old.object_name.split(',')
          parts.shift()

          console.log(old.is_hot, old.is_hot === 1, old.is_hot === '1', old)
          newo.objectName = utf8.decode(old.object_name).split(',')[0]
          newo.address = utf8.decode(parts.join(','))
          newo.csrId = old.rental_object_id
          newo.bedrooms = old.bedrooms
          newo.bathrooms = old.bathrooms
          newo.price = old.price
          newo.maxPeople = old.max_guests
          newo.mapCoords = old.map
          // newo.exactType = old.abc
          newo.type = (parseInt(old.type_id) === 1 ? '5bc8706e35e8e07d222a25ac' : '5bc8707335e8e07d222a25ad')
          newo.region = regions[old.region]
          newo.propertiesShort = utf8.decode(old.properties).split('<hr />')[0]
          newo.propertiesExtended = utf8.decode(old.properties).split('<hr />')[1]
          newo.urlFriendlyName = old.object_friendly_url
          newo.sortOrder = parseInt(old.sort_order)
          newo.aircon = old.aircon === '1' ? 1 : 0
          newo.calendar = old.calendar === '1' ? 1 : 0
          newo.is_front = old.is_front === '1' ? 1 : 0
          newo.is_hot = old.is_hot === '1' ? true : false
          newo.parking = old.parking === '1' ? 1 : 0
          newo.pool = old.pool === '1' ? 1 : 0
          newo.terrace = old.terrace === '1' ? 1 : 0
          newo.visible = old.visible === '1' ? 1 : 0
          prepped.push(newo)
        }
      }
      prepped.forEach(item => {
        api.saveItem(this.apiUrl, 'objects', item)
      })
    },
    importPropertyVars (data) {
      this.properties = {}
      data[2].data.forEach(one => {
        this.properties[one.rental_object_property_id] = utf8.decode(one.property_name)
      })
    },

    importSiteTranslations (data) {
      const langs = {
        0: 'et',
        1: 'en',
        2: 'ru',
        3: 'fi',
        128: 'es'
      }

      let t = {}

      data[2].data.forEach(one => {
        let key = utf8.decode(one.sys_sona)
        if (!t[key]) {
          t[key] = {}
        }
        if (one.sona) {
          t[key][langs[one.keel]] = utf8.decode(one.sona)
        }
        t[key].sst_id = one.sst_id
        // console.log('one', one)
      })
      Object.keys(t).forEach(key => {
        if (t[key].fi && t[key].sst_id === '122') {
          let one = t[key]
          let payload = {

            fieldName: key,
            translation_et: one.et,
            translation_fi: one.fi,
            translation_en: one.en,
            translation_es: one.es,
            translation_ru: one.ru
          }
          api.saveItem(this.apiUrl, 'siteTranslations', payload)
        }
      })
    },

    importPropertyVarsTranslations (data) {
      console.log(this.properties)

      const langs = {
        0: 'et',
        1: 'en',
        2: 'ru',
        3: 'fi',
        128: 'es'
      }

      let t = {}

      data[2].data.forEach(one => {
        if (!t[one.rental_object_property_id]) {
          t[one.rental_object_property_id] = {
            property_name: this.properties[one.rental_object_property_id]
          }
        }
        one.translation = utf8.decode(one.translation)
        t[one.rental_object_property_id][langs[one.keel_id]] = one
      })
      Object.keys(t).forEach(index => {
        let one = t[index]
        let payload = {
          propertyName: one.property_name,
          translation_et: (one.et && one.et.translation) || '',
          translation_fi: (one.fi && one.fi.translation) || '',
          translation_en: (one.en && one.en.translation) || '',
          translation_es: (one.es && one.es.translation) || '',
          translation_ru: (one.ru && one.ru.translation) || '',
          oldId: index
        }
        // api.saveItem('propertyTranslations', payload)
      })
    },

    importPrices (prices) {
      let c = 0
      Object.keys(prices).forEach(id => {
        if (c < 6) {
          let rules = prices[id]
          rules.forEach(rule => {
            // c++
            // console.log('rule for ' + id, rule)
            let d = rule.dates.split('–')
            if (d.length < 2) {
              d = rule.dates.split('-')
            }
            let data = {
              dateStart: d[0].trim(),
              dateEnd: d[1].trim(),
              object: id
            }
            if (rule.day_min3 && this.cleanInt(rule.day_min3) > 1) {
              data.dayPrice = this.cleanInt(rule.day_min3)
              data.minDays = 3
            }
            if (rule.week && this.cleanInt(rule.week) > 1) {
              data.weekPrice = this.cleanInt(rule.week)
            }
            if (rule['2weeks'] && this.cleanInt(rule['2weeks']) > 1) {
              data.twoWeekPrice = this.cleanInt(rule['2weeks'])
            }
            if (rule.month_min1 && this.cleanInt(rule.month_min1) > 1) {
              data.monthPrice = this.cleanInt(rule.month_min1)
            }
            if (rule.month_min3 && this.cleanInt(rule.month_min3) > 1) {
              data.monthPrice = this.cleanInt(rule.month_min3)
              data.minMonths = 3
            }
            /*
            minMonths
            monthPrice
            twoWeekPrice
            if (name === '1 {nädal} (7 {ööd})') name = 'week'
            else if (name === '2 {nädalat} (14 {ööd})') name = '2weeks'
            else if (name === '{öö} ({min}. 3 {ööd})') name = 'day_min3'
            else if (name === '{öö} ({min} 3 {ööd})') name = 'day_min3'
            else if (name === '{kuu} (min. 3 {kuud})') name = 'month_min3'
            else if (name === '{kuu} (min. 1 {kuud})') name = 'month_min1'
            else if (name === '{kuu} (min. 6 {kuud})') name = 'month_min6'
            else if (name === '1 {kuu}') name = 'month_min1'
            else if (name === '{kuu}') name = 'month_min1'
            else if (name === '850 € / {nädal} ( 7 {ööd} )') {

            */

            if (id === '5c67b56d58b9e87652652b32') {
              // console.log('data', data)
            }
            api.saveItem(this.apiUrl, 'prices', data)
          })
        }
      })
    },

    convertObjectFeatures () {
      let notFound = []
      let lines = []
      api.getListItemsToStore(this.apiUrl, 'propertyTranslations', [{
        key: 'rowsPerPage',
        value: 1000
      }]).then(result => {
        const translations = result.items
        api.getListItemsToStore(this.apiUrl, 'features', [{
          key: 'rowsPerPage',
          value: 1000
        }]).then(fresult => {
          const features = fresult.items
          let featuresByCode = {}
          features.forEach(feature => {
            featuresByCode[feature.code] = feature
          })
          api.getListItemsToStore(this.apiUrl, 'objects', [{
            key: 'rowsPerPage',
            value: 500
          }]).then(response => {
            response.items.forEach(item => {
              if (1 || item['_id'] === '5c67b56d58b9e87652652b22') {
                // console.log('propertiesExtended', item.propertiesShort, item.propertiesExtended)
                [notFound, lines] = this.getFeaturesFromText(features, item, item.propertiesShort, notFound, lines);
                [notFound, lines] = this.getFeaturesFromText(features, item, item.propertiesExtended, notFound, lines)
              }
            })
            response.items.forEach(item => {
              let features = lines.filter(line => line.feature && line.id === item['_id'])
              let objectFeatures = {}
              features.forEach(feature => {
                let featureId = featuresByCode[feature.feature]['_id']
                objectFeatures[featureId] = {
                  checked: true,
                  distance: feature.distance
                }
              })
              item.features = objectFeatures
              if (item['_id'] !== '5c67b56d58b9e87652652b22') {
                api.saveItem(this.apiUrl, 'objects', item)
              }
            })
          })
        })
      })
    },

    c (line) {
      if (!line || !line.match(/{/g)) { return 0 }
      return parseInt(line.match(/{/g).length)
    },

    getFeaturesFromText (features, object, text, notFound, lines) {
      let newLines = text.split('\n')
        .filter(line => line.includes('<li>'))
        .map(line => {
          line = line.replace('{m}', 'm')
          line = line.replace('{km}', 'km')
          line = line.replace(/<\/?[^>]+(>|$)/g, '').trim()
          let feature = null
          let distance = null
          if (line.includes('parkimine')) {
            if (line.includes('garaažis') && line.includes('tänaval') && this.c(line) === 3) {
              feature = 'parking_on_street_or_garage'
            } else if (line.includes('garaažis') && line.includes('tänaval') && line.includes('{ja}') && this.c(line) === 4) {
              feature = 'parking_on_street_or_garage'
            } else if (line.includes('garaažis') && this.c(line) === 2) {
              feature = 'parking_in_garage'
            } else if (line.includes('tänaval') && this.c(line) === 2) {
              feature = 'parking_on_street'
            } else if (this.c(line) === 1) {
              feature = 'parking'
            }
            // console.log(this.c(line), line, feature)
          } else if (line.includes('Wi-Fi')) {
            if (line === '{Wi-Fi}' ||
            line === 'Wi-Fi'
            ) {
              feature = 'wifi'
            } else if (line === 'Wi-Fi ({tasuline})' ||
              line === 'Wi-Fi {tasuline}' ||
              line === '{Wi-Fi} ({tasuline})' ||
              line === '{Wi-Fi} ({tasuline})'
            ) {
              feature = 'wifi_extra_charge'
            }
            // console.log(line, feature)
          } else if (line.includes('köök')) {
            if (line === '{Wi-Fi}' ||
            line === 'Wi-Fi'
            ) {
              feature = 'wifi'
            } else if (line === 'Wi-Fi ({tasuline})' ||
              line === 'Wi-Fi {tasuline}' ||
              line === '{Wi-Fi} ({tasuline})' ||
              line === '{Wi-Fi} ({tasuline})'
            ) {
              feature = 'wifi_extra_charge'
            }
            console.log(line, feature)
          } else {
            features.forEach(search => {
              if (this.c(line) === 1 && search.mappingCode && line.includes(search.mappingCode)) {
                feature = search.code
                features.forEach(search => {
                  if (search.defineDistance && line.includes(':')) {
                    distance = line.split(':')[1]
                  }
                  // console.log('SEARCH', line, search)
                })
              } else if (line === search.mappingCode) {
                // Exact match
                feature = search.code
                // console.log('EXACT MATCH', line, feature)
              }
            })
          }
          if (!feature) {
            if (line.includes('{turismiluba}')) {
              turismiluba[object['_id']] = line
              // else if (line.includes('{magamistoaga}') ||
              // LEAVE
              // line.includes('{elutuba}') ||
              // line.includes('{vannitoaga}') ||
              // line.includes('{vannituba}') ||
              // line.includes('{magamistuba}') ||
              // line.includes('{täiskasvanut}') ||
              // line.includes('{katusekorter}') ||
              // line.includes('{korter}') ||
              // line.includes('{villa}') ||
              // line.includes('{lux') ||
              // line.includes('{asukoht (aadress)}') ||
              // line.includes('{paarismaja}') ||
              // line.includes('{kaheinimese voodi}') ||
              // line.includes('{diivanvoodi}') ||
              // line.includes('{ridaelamu}') ||
              // line.includes('{paarismaja}') ||
              // line.includes('{magamistuba}') ||
              // line.includes('{korrust}') ||
              // line.includes('{korrus}') ||
              // line.includes('{köök}') ||
              // line.includes('{magamistuba}') ||
              // line.includes('{magamistuba}') ||
              // this.c(line) === 0
              // ) {
              // TODO
              // }
            } else {
              console.log('NOT FOUND..', line)
              notFound.push({
                objectName: object.name_en,
                csrId: object.csrId,
                line: line
              })
            }
          }
          return {
            id: object['_id'],
            line: line,
            feature: feature,
            distance: distance && distance.trim()
          }
        })
      return [notFound, [...lines, ...newLines]]
    },

    convertPrices () {
      console.log('convert-prices')
      api.getListItemsToStore(this.apiUrl, 'objects', [{
        key: 'rowsPerPage',
        value: 500
      }]).then(response => {
        let objectPrices = {}
        response.items.forEach((item, index) => {
          // console.log(index, item)

          if (item.propertiesExtended && ![144, 183, 125].includes(item.csrId)) {
            let descr = item.propertiesExtended
            let html = new DOMParser().parseFromString(descr, 'text/html')
            let table = html.getElementsByTagName('table')
            let json = new HtmlTableToJson(table[0].outerHTML)
            let priceRules = []
            if (json && json.results && json.results[0]) {
              let rows = json.results[0]
              // console.log('rows', rows)
              if (rows && rows[0]) {
                let periods = []
                if (item._id === '5c67b56d58b9e87652652b32') {
                  console.log('rows', rows)
                }
                Object.keys(rows[0]).forEach(key => {
                  if (key > 1) {
                    if (rows[0][key]) {
                      let name = rows[0][key]
                      if (name === '1 {nädal} (7 {ööd})') name = 'week'
                      else if (name === '2 {nädalat} (14 {ööd})') name = '2weeks'
                      else if (name === '{öö} ({min}. 3 {ööd})') name = 'day_min3'
                      else if (name === '{öö} ({min} 3 {ööd})') name = 'day_min3'
                      else if (name === '{kuu} (min. 3 {kuud})') name = 'month_min3'
                      else if (name === '{kuu} (min. 1 {kuud})') name = 'month_min1'
                      else if (name === '{kuu} (min. 6 {kuud})') name = 'month_min6'
                      else if (name === '1 {kuu}') name = 'month_min1'
                      else if (name === '{kuu}') name = 'month_min1'
                      else if (name === '850 € / {nädal} ( 7 {ööd} )') {
                        // console.log(item)
                      } else {
                        // console.log (item.csrId, name)
                      }
                      periods.push(name)
                    }
                  }
                })
                rows.forEach((row, index) => {
                  if (index > 0) {
                    let priceRule = {}
                    priceRule.dates = row[1]
                    periods.forEach((period, periodIndex) => {
                      priceRule[period] = row[periodIndex + 2]
                    })
                    priceRules.push(priceRule)
                  }
                })
                objectPrices[item._id] = priceRules
                // console.log('priceRules', priceRules)
              }
            }
          }
        })

        this.importPrices(objectPrices)
      })
    },

    cleanInt (string) {
      return parseInt(string.replace(/\s+/g, ''))
    },

    importData (filedata) {
      //this.convertObjectFeatures()
      //return
      //this.convertPrices()
      //return
      let data = this.getJson(filedata)
      if (data[2].name === 'ext_rental_object') {
        this.importObjects(data)
      } else if (data[2].name === 'ext_booking') {
        this.importBookings(data)
      } else if (data[2].name === 'sys_sonad') {
        this.importSiteTranslations(data)
      } else if (data[2].name === 'ext_image') {
        this.importImages(data)
      } else if (data[2].name === 'ext_rental_object_property_translation') {
        this.importPropertyVarsTranslations(data)
      } else if (data[2].name === 'ext_rental_object_property') {
        this.importPropertyVars(data)
      }
    }
  }
}
</script>
